import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FDBox, FDSearchInput, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import ScenarioSelectionAssumptionSection from './ScenarioSelectionAssumptionSection';

export const MatchesSearchTerm = (field, searchTerm) => {
  return field.replace(/\s/g, '').toLowerCase().includes(searchTerm.replace(/\s/g, '').toLowerCase());
};

const ScenarioSelectionAssumptionSections = ({ collection }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const isMobile = useMobileLayout();

  const handleChange = (term) => {
    setSearchTerm(term);
  };

  const anyLineItemMatchesSearch = (lineItems) => {
    return lineItems.some((item) => MatchesSearchTerm(item.attr('title'), searchTerm));
  };

  const elms = collection.resources().list().map((resource) => {
    const sectionTitleMatches = MatchesSearchTerm(resource.attr('title'), searchTerm);
    const anyLineItemMatches = anyLineItemMatchesSearch(resource.attr('lineItems')?.resources().list() || []);

    if (!sectionTitleMatches && !anyLineItemMatches) {
      return null;
    }

    return (
      <FDBox key={resource.id()} flex={1}>
        <ScenarioSelectionAssumptionSection resource={resource} searchTerm={searchTerm} showLineItems={sectionTitleMatches && !anyLineItemMatches} />
      </FDBox>
    );
  });

  return (
    <FDStack direction={'column'} spacing={3}>
      <FDBox flex={1} width={isMobile ? '100%' : '100%'} maxWidth={350} alignSelf={'center'}>
        <FDSearchInput
          {...dataAttrs('assumption-search-bar-input')}
          placeholder={'Search by Keyword'}
          onChange={(e) => handleChange(e.target.value)}
          value={searchTerm}
          fullWidth
        />
      </FDBox>
      <FDStack direction={'column'} spacing={3}>
        {elms}
        {/* Display placeholder text if all sections have been filtered out */}
        {!elms.some((el) => el !== null) && <FDTitleText value={'No assumptions found for keyword.'} />}
      </FDStack>
    </FDStack>
  );
};

ScenarioSelectionAssumptionSections.propTypes = {
  collection: PropTypes.object.isRequired,
};

ScenarioSelectionAssumptionSections.defaultProps = {};

export default ScenarioSelectionAssumptionSections;
